export const protocol = process.env.NEXT_PUBLIC_APP_ENV === 'development' ? 'http' : 'https';
